import { render, staticRenderFns } from "./setPwd.vue?vue&type=template&id=e5d9b66e"
import script from "./setPwd.vue?vue&type=script&lang=js"
export * from "./setPwd.vue?vue&type=script&lang=js"
import style0 from "./setPwd.vue?vue&type=style&index=0&id=e5d9b66e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports